// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input[disabled][data-v-01b2a758], .input[data-v-01b2a758]:disabled, .input.is-disabled[data-v-01b2a758] {\n  box-shadow: none;\n}", ""]);
// Exports
module.exports = exports;
